import { render, staticRenderFns } from "./QuickAction.vue?vue&type=template&id=0fee52ae&scoped=true&"
import script from "./QuickAction.vue?vue&type=script&lang=js&"
export * from "./QuickAction.vue?vue&type=script&lang=js&"
import style0 from "./QuickAction.vue?vue&type=style&index=0&id=0fee52ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fee52ae",
  null
  
)

export default component.exports